// extracted by mini-css-extract-plugin
export default {"uploadImageSection":"UploadImage_uploadImageSection__y7kmV","uploadImageTitle":"UploadImage_uploadImageTitle__Dbqvv","uploadImageImage":"UploadImage_uploadImageImage__4EoCT"};